<template>
  <span>
    <v-container fluid class="pa-0 overflow-hidden">

      <VuetifyRender class="pa-0" :html="introOneData"></VuetifyRender>

  </v-container>
  </span>
</template>

<script setup>
const props = defineProps({
  introOne: {
    type: String,
    default: "",
  },
});
let introOneData = props.introOne;


let parsed = true;


const getHeight = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 230;
    case "sm":
      return 280;
    case "md":
      return 300;
    case "lg":
      return 355;
    case "xl":
      return 390;
    case "xxl":
      return 440;
    default:
      return 300;
  }
});

const cardwidth = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 100;
    case "sm":
      return 90;
    case "md":
      return 80;
    case "lg":
      return 70;
    case "xl":
      return 60;
    case "xxl":
      return 50;
    default:
      return 50;
  }
});

const { PUBLIC_DATA_URL } = useRuntimeConfig().public
const isDev = process.env.NODE_ENV !== 'production'

// Replace /PUBLIC with PUBLIC_DATA_URL in development environment to load icons correctly from bucket
if (isDev){
  introOneData = introOneData.replaceAll("/PUBLIC", PUBLIC_DATA_URL)
}
</script>
